/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Importing_Events_ToastInputs */

const en_plain_text_import_importing_events_toast = /** @type {(inputs: Plain_Text_Import_Importing_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing events...`)
};

const fr_plain_text_import_importing_events_toast = /** @type {(inputs: Plain_Text_Import_Importing_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des evenements...`)
};

const de_plain_text_import_importing_events_toast = /** @type {(inputs: Plain_Text_Import_Importing_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse werden importiert...`)
};

const it_plain_text_import_importing_events_toast = /** @type {(inputs: Plain_Text_Import_Importing_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione eventi in corso...`)
};

const ru_plain_text_import_importing_events_toast = /** @type {(inputs: Plain_Text_Import_Importing_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт событий...`)
};

const es_plain_text_import_importing_events_toast = /** @type {(inputs: Plain_Text_Import_Importing_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando eventos...`)
};

const zh_cn2_plain_text_import_importing_events_toast = /** @type {(inputs: Plain_Text_Import_Importing_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在导入事件...`)
};

const ja_plain_text_import_importing_events_toast = /** @type {(inputs: Plain_Text_Import_Importing_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントをインポートしています...`)
};

const hi_plain_text_import_importing_events_toast = /** @type {(inputs: Plain_Text_Import_Importing_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट आयात किए जा रहे हैं...`)
};

const pt_pt2_plain_text_import_importing_events_toast = /** @type {(inputs: Plain_Text_Import_Importing_Events_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando eventos...`)
};

/**
* | output |
* | --- |
* | "Importing events..." |
*
* @param {Plain_Text_Import_Importing_Events_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_importing_events_toast = /** @type {((inputs?: Plain_Text_Import_Importing_Events_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Importing_Events_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_importing_events_toast(inputs)
	if (locale === "de") return de_plain_text_import_importing_events_toast(inputs)
	if (locale === "it") return it_plain_text_import_importing_events_toast(inputs)
	if (locale === "ru") return ru_plain_text_import_importing_events_toast(inputs)
	if (locale === "es") return es_plain_text_import_importing_events_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_importing_events_toast(inputs)
	if (locale === "ja") return ja_plain_text_import_importing_events_toast(inputs)
	if (locale === "hi") return hi_plain_text_import_importing_events_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_importing_events_toast(inputs)
	return en_plain_text_import_importing_events_toast(inputs)
});